import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { SwitchWrapper } from '../../../switch/SwitchWrapper';
import { TemplateFormSwitchToggleFieldMeta } from './interfaces/template-form-switch-toggle-field-meta';

export function TemplateFormSwitchToggleField({
  field,
  form,
  metadata,
  formDisabled
}: TemplateFormFieldProps) {
  const { switchProps, helperText, ...wrapperProps } =
    metadata as TemplateFormSwitchToggleFieldMeta;

  return (
    <SwitchWrapper
      {...wrapperProps}
      disabled={switchProps?.disabled || formDisabled}
      switchProps={{
        ...switchProps,
        checked: !!field.value,
        onChange: (_, checked) => {
          (async () => {
            await form.setFieldValue(field.name, checked);
          })();
        }
      }}
    >
      {helperText}
    </SwitchWrapper>
  );
}
